import dayjs from 'dayjs'

export const RACE_COMMERCIAL_ITEM_DEFAULT: number = 1;
export const RACE_COMMERCIAL_ITEM_ADDITIONAL: number = 2;

export class RaceCommercialItem {
  constructor(public id?: number,
              public raceId?: number,
              public registrationFeeTypeId?: number,
              public name?: string,
              public nameEng?: string,
              public nameSlo?: string,
              public nameSr?: string,
              public nameBs?: string,
              public nameIta?: string,
              public internalDescription?: string,
              public internalDescriptionEng?: string,
              public internalDescriptionIta?: string,
              public internalDescriptionSlo?: string,
              public internalDescriptionSr?: string,
              public internalDescriptionBs?: string,
              public priceConstantByPeriod?: boolean,
              public vat?: number,
              public vatExplanation?: string,
              public vatExplanationEng?: string,
              public vatExplanationSlo?: string,
              public vatExplanationIta?: string,
              public vatExplanationSr?: string,
              public vatExplanationBs?: string,
              public price?: number,
              public priceWithDiscount?: number,
              public periods?: RaceCommercialItemPeriod[]) {
  }

  //Price effective at the given moment
  public static getEffectivePrice(raceCommercialItem?: RaceCommercialItem, at: Date = new Date()): number | undefined {
    if (!raceCommercialItem) {
      return undefined;
    }
    if (raceCommercialItem.priceConstantByPeriod !== false) {
      return raceCommercialItem.price ?? undefined;
    }
    const activePeriod = raceCommercialItem.periods?.find((period: RaceCommercialItemPeriod) =>
      RaceCommercialItemPeriod.covers(period, at));
    return activePeriod?.price ?? raceCommercialItem.price ?? undefined;
  }

  public static isVisible(raceCommercialItem: RaceCommercialItem): boolean {
    return true;
/*    let visible: boolean = false;
    if (raceCommercialItem.priceConstantByPeriod) {
      visible = true;
    } else if (!raceCommercialItem.priceConstantByPeriod && raceCommercialItem.periods && raceCommercialItem.periods.length > 0) {
      for (let i: number = 0; i < raceCommercialItem.periods.length; i++) {
        let currentDate = Date.now();
        if ((dayjs(currentDate).isSame(raceCommercialItem.periods[i].startDate) || dayjs(currentDate).isAfter(raceCommercialItem.periods[i].startDate))
          && dayjs(currentDate).isBefore(raceCommercialItem.periods[i].endDate) && raceCommercialItem.periods[i].price) {
          visible = true;
          raceCommercialItem.price = raceCommercialItem.periods[i].price!;
          break;
        }
      }
    }
    return visible;*/
  }
}

export class RaceCommercialItemPeriod {
  constructor(public id?: number,
              public startDate?: Date,
              public endDate?: Date,
              public price?: number) {
  }

  // Finds current period
  public static covers(period: RaceCommercialItemPeriod, at: Date = new Date()): boolean {
    const moment = dayjs(at);
    if (period.startDate && moment.isBefore(dayjs(period.startDate).startOf('day'))) {
      return false;
    }
    if (period.endDate && moment.isAfter(dayjs(period.endDate).endOf('day'))) {
      return false;
    }
    return !!(period.startDate || period.endDate);
  }

  public static checkForOverlaps(periods: RaceCommercialItemPeriod[]): {
    period1: RaceCommercialItemPeriod,
    period2: RaceCommercialItemPeriod
  }[] {
    const overlappingPairs: { period1: RaceCommercialItemPeriod, period2: RaceCommercialItemPeriod }[] = [];
    for (let i = 0; i < periods.length; i++) {
      const start_i = dayjs(periods[i].startDate)
      const end_i = dayjs(periods[i].endDate)
      for (let j = i + 1; j < periods.length; j++) {
        const start_j = dayjs(periods[j].startDate)
        const end_j = dayjs(periods[j].endDate)
        if (start_i.isBefore(end_j) && end_i.isAfter(start_j)) {
          overlappingPairs.push({period1: periods[i], period2: periods[j]});
        }
      }
    }
    return overlappingPairs;
  }
}
